import { render } from "./Org.vue?vue&type=template&id=02c8fc64&scoped=true"
import script from "./Org.vue?vue&type=script&lang=js"
export * from "./Org.vue?vue&type=script&lang=js"

import "./Org.vue?vue&type=style&index=0&id=02c8fc64&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bmark-kid/bmark-kid-manage-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c8fc64"]])

export default __exports__